<template>
    <div style="width:100%" class="d-flex align-center px-0 pt-0 pb-2">
        <span class="mr-2 pr-4 text--primary"><translation-container :context="this" value="If"></translation-container></span>
        <v-select
            v-model="selected_items"
            :items="options"
            item-text="text"
            item-value="value"
            :label="Translate('Select Direction')"
            outlined
            dense
            class="ml-2 mr-2"
            background-color="white"
            hide-details
            :rules="valueRules"
            :error-messages="valueErrorMessages"
            :error="valueErrorMessages.length > 0"></v-select>
        <span class="mx-2 text--primary"><translation-container :context="this" value="then"></translation-container></span>
        <ThresholdformatOptions :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
    </div> 
</template>


<script>

    import ThresholdformatOptions from './threshold_formatOptions.vue';
    import methods from '@/Shared/methods';

    export default {
        components: {
            ThresholdformatOptions
        },
        data: function () {
            return {
                selected_items: [],
                valueErrorMessages:[]
            }
        },
        props: {
            item: Object,
            value: null,
            EventBus: null
        },
        created() {
            if (this.value && this.value.values)
                this.selected_items = this.value.values;
            else if (this.value && this.value.value)
                this.selected_items = this.value.value;        },
        watch: {
            selected_items: function (newv) {
                // When all items are selected, we disable this filter
                if (newv.length == 2 || newv.length < 1)
                    this.$emit('thresholdValuesChanged', {});
                else
                    this.$emit('thresholdValuesChanged', {
                        filterType: "set",
                        values: newv,
                        value: newv,
                        type: "direction"
                    });
            },
        },
        computed:{
            options() {
                return [
                    { text: this.Translate('Inbound'), value: 'inbound' },
                    { text: this.Translate('Outbound'), value: 'outbound' }
                ];
            },
            valueRules() {
                return [
                    v => v.length || this.Translate('Please select a value')
                ];
            },
        },        
        methods: {
            ...methods,
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
        },
        triggerValidation() {
            this.valueErrorMessages = [];
            for (const rule of this.valueRules) {
                const result = rule(this.selected_items);
                if (typeof result === 'string') {
                    this.valueErrorMessages.push(result);
                    break; // Stop at the first error
                }
            }
        },             
    }
</script>

<style scoped>
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }
</style>